import { NgModule, ErrorHandler, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { RouteReuseStrategy } from '@angular/router';
import { IonicStorageModule } from '@ionic/storage-angular';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'; // No need to reference ./lib/http-loader
import { Ionic2RatingModule } from 'ionic2-rating';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// Native Plugins
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { CallNumber } from '@awesome-cordova-plugins/call-number/ngx';
import { Network } from '@awesome-cordova-plugins/network/ngx';
import { Camera } from '@awesome-cordova-plugins/camera/ngx';
import { Device } from '@awesome-cordova-plugins/device/ngx';

// Services
import { InterceptorService } from './services/interceptor.service';
// import { CustomErrorHandler } from './services/custom-error-handler.service';
// import { LoggerService } from './services/logger.service';

// Custom Animations
import {
    pageTransition,
    customAlertEnter, customAlertLeave,
    customModalEnter, customModalLeave,
    customLoaderEnter, customLoaderLeave,
} from './animations/customAnimation';

// UI Components
import { CitationModalPage } from './pages/citation-modal/citation-modal.page';
import { SignupModalPage } from './signup-modal/signup-modal.page';
// import { RatingPage } from './calendar/rating/rating.page';
// import { RatingComponentForm } from './calendar/rating/component/rating-form.component';
// import { SelectionPage } from './calendar/selection/selection.page';
import { BmiPage } from './calendar/bmi/bmi.page';
import { AboutusPage } from './pages/aboutus/aboutus.page';
import { AreaListsPage } from './pages/area-lists/area-lists.page';
import { MenuDetailPage } from './menu/menu-detail/menu-detail.page';
import { CustomizationModalPage } from './menu/customization-modal/customization-modal.page';
import { OtpVerificationPage } from './pages/otp-verification/otp-verification.page';
import { TermsAndConditionsPage } from './pages/terms-and-conditions/terms-and-conditions.page';
import { LimitedModalPage } from './pages/limited-modal/limited-modal.page';
import { AutocompletePage } from './pages/autocomplete/autocomplete.page';
import { AddAddressPage } from './pages/add-address/add-address.page';
import { EditAddressPage } from './pages/edit-address/edit-address.page';
import { SubscriptionDetailPage } from 'src/app/accounts/subscription-list/subscription-detail/subscription-detail.page';

// Additional Modules
// import { NgxChartsModule } from '@swimlane/ngx-charts';
// import { NgxPaginationModule } from 'ngx-pagination';
import { CommonModule } from '@angular/common';
import { SharedModule } from './shared/shared.module';
import { APP_INITIALIZER } from '@angular/core';
import { ConfigService } from './provider/config.service';

export function initializeApp(configService: ConfigService) {
  return () => configService.getAppSettings();
}

// Factory function for TranslateLoader
export function setTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AppComponent,
        CitationModalPage, SignupModalPage, BmiPage, AboutusPage,
      CustomizationModalPage,
        OtpVerificationPage, 
        LimitedModalPage, AutocompletePage,
         SubscriptionDetailPage
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        Ionic2RatingModule,
        SharedModule,
        IonicStorageModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: setTranslateLoader,
                deps: [HttpClient]
            }
        }),
        AppRoutingModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:30000'
        }),
        IonicModule.forRoot({
            mode: 'ios',
            animated: true,
            navAnimation: pageTransition,
            alertEnter: customAlertEnter,
            alertLeave: customAlertLeave,
            modalEnter: customModalEnter,
            modalLeave: customModalLeave,
            loadingEnter: customLoaderEnter,
            loadingLeave: customLoaderLeave,
            backButtonIcon: 'arrow-back',
            backButtonText: '',
            swipeBackEnabled: false
        })
    ],
    providers: [
        ScreenOrientation,
        Network,
        Device,
        Camera,
        CallNumber,
        AppVersion,
        InAppBrowser,
        // Clipboard,
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [ConfigService ],
            multi: true
        },
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule { }